import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';

import { Field } from '../components/Field/Field.js'
import { withTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';

import { returnField } from '../utils/formHelpers';

import { updateProjectNotes } from '../store/actions/projectNotesActions';
import NoAccess from '../components/navigation/NoAccess';

import CardWrapper from '../components/common/CardWrapper';
import { useTheme } from '@mui/material';
import { fastDeepEqual } from '../utils/object.js'


const inlineStyles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
});

let Notes = ({
  admin,
  initialValues,
  t,
  updateProjectNotes
}) => {
  const [formValues, setFormValues] = useState(initialValues || { projectNotes: '' })
  const [submitting, setSubmitting] = useState(false)

  const pristine = fastDeepEqual(initialValues, formValues)

  const submitNotes = useCallback(async event => {
    event.preventDefault()
    setSubmitting(true)
    await updateProjectNotes(formValues)
    setSubmitting(false)
  }, [
    formValues,
    updateProjectNotes
  ])

  const theme = useTheme();
  const classes = inlineStyles(theme);
  return admin ? (
    <CardWrapper name={t('projectDetailView.notes')} headline>
      <form onSubmit={submitNotes}>
        <Field
          component={returnField('editor')}
          fullWidth
          label={t('projectDetailView.notesDescription')}
          name="projectNotes"
          required
          setValue={setFormValues}
          type="text"
          value={formValues.projectNotes}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={classes.button}
          disabled={submitting || pristine}
        >
          {t('common.save')}
          <Icon sx={classes.rightIcon}>cloud_upload</Icon>
        </Button>
      </form>
    </CardWrapper>
  ) : (
    <NoAccess />
  );
};

const mapStateToProps = (state, ownProps) => {
  const pid = R.path(['pid'], ownProps);

  const initValues = {
    projectNotes: '',
  };

  return {
    initialValues: pid
      ? R.path(['projectNotes', 'projectNotes', pid], state)
      : initValues,
    admin: R.path(['user', 'admin'], state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateProjectNotes: values =>
    dispatch(
      updateProjectNotes(
        values,
        R.path(['pid'], ownProps),
        R.path(['t'], ownProps)
      )
    ),
});

Notes = connect(mapStateToProps, mapDispatchToProps)(Notes);

export default withTranslation('translations')(Notes);
